var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path3, _circle7, _circle8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradeUnions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.95V22.95C30 19.6363 27.3137 16.95 24 16.95H23V27.95C23 28.5023 23.4477 28.95 24 28.95H29C29.5523 28.95 30 28.5023 30 27.95Z",
    fill: "#D59829",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.45C14 13.9647 16.0147 11.95 18.5 11.95C20.9853 11.95 23 13.9647 23 16.45V27.95C23 28.5023 22.5523 28.95 22 28.95H16C14.8954 28.95 14 28.0546 14 26.95V16.45Z",
    fill: "#D59829",
    fillOpacity: 0.2,
    stroke: "#C78817",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 15.95,
    r: 1,
    fill: "#C78817"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 19.95,
    r: 1,
    fill: "#C78817"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 23.95,
    r: 1,
    fill: "#C78817"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 15.95,
    r: 1,
    fill: "#C78817"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19.95,
    r: 1,
    fill: "#C78817"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 23.95,
    r: 1,
    fill: "#C78817"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.95V16.2C22.5858 16.2 22.25 16.5358 22.25 16.95H23ZM28.75 28.95C28.75 29.3642 29.0858 29.7 29.5 29.7C29.9142 29.7 30.25 29.3642 30.25 28.95H28.75ZM23 17.7H26V16.2H23V17.7ZM28.75 20.45V28.95H30.25V20.45H28.75ZM23.75 26.95V16.95H22.25V26.95H23.75ZM26 17.7C27.5188 17.7 28.75 18.9312 28.75 20.45H30.25C30.25 18.1028 28.3472 16.2 26 16.2V17.7Z",
    fill: "#C78817"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 19.95,
    r: 1,
    fill: "#C78817"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 23.95,
    r: 1,
    fill: "#C78817"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeUnions);
export default __webpack_public_path__ + "static/media/tradeUnions.4ae53df97ac1ff6459fd305c51c4ecee.svg";
export { ForwardRef as ReactComponent };